import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../../Services/MasterDataService';
import { RecurrenceConsoleService } from '../../Services/RecurrenceConsoleService';
import { ListResponse } from '../../Models/ResponseModels';
import { RecurrenceUpdate } from '../RecurrenceUpdate/RecurrenceUpdate';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RecurrenceLookup } from '../../Models/RequestModels';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'RecurrencePopover',
    templateUrl: './RecurrencePopover.html'
})

export class RecurrencePopover extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('recurrenceUpdate') recurrenceUpdate: RecurrenceUpdate;
    @ViewChild('content') content;

    ModalRef: NgbModalRef;
    Model: any;
    RecurrenceLookupModel: RecurrenceLookup;
    ActivityLog: ListResponse;
    DateFormat: string;
    ModificationLog: ListResponse;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public recurrenceConsoleService: RecurrenceConsoleService, private modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnDestroy(): void {

    }

    @Input() set Selected(data: any) {
        if (data == null) {
            this.Model = null;
            return;
        }
        if (this.Model == data)
            return;

        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
        this.Model = data;
        this.onOpen();
    }

    @Output() Deleted = new EventEmitter<boolean>();
    @Output() RecurrenceChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
        this.RecurrenceLookupModel = new RecurrenceLookup();
        this.RecurrenceLookupModel.PageSize = 10;
        this.SetData();
    }

    onOpen(): void {
        this.RecurrenceLookupModel.RecurrenceId = this.Model.RecurrenceId;
        this.ActivityLog = new ListResponse();
        this.SetData();
    }

    SetData(): void {
        this.GetActivityLog();
        this.GetModificationLog();
    }

    GetActivityLog() {
        if (this.Model == null)
            return;

        this.IsSubmitting = true;
        this.RecurrenceLookupModel.PageSize = 10;
        this.recurrenceConsoleService.GetActivityLog(this.RecurrenceLookupModel)
            .then(data => {
                this.ActivityLog = data;
                this.IsSubmitting = false;
            }).catch (err=> {
                this.IsSubmitting = false;
            });
    }

    GetModificationLog() {
        if (this.Model == null) {
            return;
        }
        this.IsSubmitting = true;
        this.recurrenceConsoleService.GetModificationLog(this.Model.PropertyId, this.RecurrenceLookupModel).then(data => {
            this.ModificationLog = data;
            this.IsSubmitting = false;
        }).catch(err => {
            this.IsSubmitting = false;
        });
    }

    EditRecurrence(): void {
        this.Model.OccurrenceCount = this.ActivityLog.Result.length;
        this.recurrenceUpdate.Open(this.Model);
    }

    DeleteAlert(): void {
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        //this.ModalRef.close();
    }

    Delete(): void {
        this.recurrenceConsoleService.Delete(this.Model.RecurrenceId)
            .then(data => {
                if (data.HasError) {
                    this.GetMultilingualToast(data.Errors[0].ErrorMessage, 'error');
                }
                else if (data.Result) {
                    const [model] = data.Result;
                    this.Model = model;
                    this.Deleted.emit(model);
                }
                this.ModalRef.close();
            });
    }

    OnPageChange(): void {
        this.SetData();
    }
}
